import React from "react";
import "../../styles/CaseStudyThree/CaseStudiesCallout3.css";
import productIcon1 from "../../assets/purple-people.png";
import productIcon2 from "../../assets/google-logo.png";
import productIcon3 from "../../assets/big-magnifying-glass.png";
import { Link } from 'react-router-dom';

const CaseStudiesCallout3 = () => {
  return (
    <section className="case-callout-section3">
      <div className="case-callout-container3">
        {/* Title */}
        <h2 className="case-callout-title3">Ready to Make Your Case Study?</h2>

        {/* Description Text */}
        <p className="case-callout-description3">
        Let us help you achieve similar results! Hawx Pest Control's success showcases the power of strategic targeting and optimization.
        </p>

        {/* Product/Service Boxes */}
        <div className="case-callout-product-container3">
          <div className="case-callout-box3">
            <img
              src={productIcon1}
              alt="Product/Service Callout 1"
              className="case-callout-icon3"
            />
            <p>Audience Segmentation</p>
          </div>
          <div className="case-callout-box3">
            <img
              src={productIcon2}
              alt="Product/Service Callout 2"
              className="case-callout-icon3"
            />
            <p>Campaign Management</p>
          </div>
          <div className="case-callout-box3">
            <img
              src={productIcon3}
              alt="Product/Service Callout 3"
              className="case-callout-icon3"
            />
            <p>Data-Driven Optimization</p>
          </div>
        </div>
      </div>

      {/* CTA Below Cards */}
      <div className="case-callout-cta3">
        <p className="case-callout-cta-text3">Click below to Schedule Your FREE Growth Audit!</p>
        <Link to="/lead-form" className="case-callout-cta-button3">Get Your Growth Audit</Link>
      </div>

    </section>
  );
};

export default CaseStudiesCallout3;
